import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import gameData from '../gameData';
import KeyboardKey from './KeyboardKey';

export default class Keyboard extends Phaser.GameObjects.Container {
  constructor(scene, startX, startY) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.x = startX;
    this.y = startY;

    this.keyboard = ABCyaPhaser.Images.addImage(0, 0, `${gameData.gameStyle}_Keybrd`, this);

    this.allKeys = [];
    this.sortedKeys = [];

    this.createRow1();
    this.createRow2();
    this.createRow3();
    this.createRow4();
    this.createRow5();
  }

  createRow1() {
    // console.log(gameData.layout[0]);
    this.row1 = [];
    this.shuffledRow1 = [];

    for (let i = 0; i < gameData.layout[0].length; i++) {
      const key = new KeyboardKey(this.scene, `${gameData.gameStyle}_${gameData.layout[0][i]}`);
      this.add(key);
      key.name = gameData.layout[0][i];

      if (i === 0) {
        if (gameData.gameStyle === 'Lava') {
          key.setPosition(-402, -118);
        }
        else if (gameData.gameStyle === 'Slime') {
          key.setPosition(-400, -117);
        }
        else if (gameData.gameStyle === 'Rnbow') {
          key.setPosition(-406, -122);
        }
        else {
          key.setPosition(-402, -118);
        }
      }
      else {
        if (gameData.gameStyle === 'Lava') {
          key.setPosition(this.row1[i - 1].x + (this.row1[i - 1].width / 2 + key.width / 2) - 5.2, this.row1[0].y);
        }
        else if (gameData.gameStyle === 'Classic') {
          key.setPosition(this.row1[i - 1].x + (this.row1[i - 1].width / 2 + key.width / 2) + 2.3, this.row1[0].y);
        }
        else if (gameData.gameStyle === 'Rnbow') {
          key.setPosition(this.row1[i - 1].x + (this.row1[i - 1].width / 2 + key.width / 2) - 5.6, this.row1[0].y);
        }
        else if (gameData.gameStyle === 'Slime') {
          key.setPosition(this.row1[i - 1].x + (this.row1[i - 1].width / 2 + key.width / 2) + 4.1, this.row1[0].y);
        }
        else if (gameData.gameStyle === 'SciFi') {
          key.setPosition(this.row1[i - 1].x + (this.row1[i - 1].width / 2 + key.width / 2) + 5.3, this.row1[0].y);
        }
        else {
          key.setPosition(this.row1[i - 1].x + (this.row1[i - 1].width / 2 + key.width / 2) + 2.6, this.row1[0].y);
        }
      }

      key.setStartPos(key.x, key.y);

      this.row1.push(key);
      this.allKeys.push(key);
    }
  }

  createRow2() {
    // console.log(gameData.layout[1]);
    this.row2 = [];
    this.shuffledRow2 = [];

    for (let i = 0; i < gameData.layout[1].length; i++) {
      const key = new KeyboardKey(this.scene, `${gameData.gameStyle}_${gameData.layout[1][i]}`);
      this.add(key);
      key.name = gameData.layout[1][i];

      if (i === 0) {
        if (gameData.gameStyle === 'Lava') {
          key.setPosition(-381, -59);
        }
        else if (gameData.gameStyle === 'Rnbow') {
          key.setPosition(-385, -64);
        }
        else if (gameData.gameStyle === 'Slime') {
          key.setPosition(-378, -59);
        }
        else {
          key.setPosition(-381, -59);
        }
      }
      else {
        if (i === 1) {
          if (gameData.gameStyle === 'Lava') {
            key.setPosition(-301, this.row2[0].y);
          }
          else if (gameData.gameStyle === 'Rnbow') {
            key.setPosition(-305, this.row2[0].y);
          }
          else if (gameData.gameStyle === 'Slime') {
            key.setPosition(-299, this.row2[0].y);
          }
          else {
            key.setPosition(-301, this.row2[0].y);
          }
        }
        else {
          if (gameData.gameStyle === 'Lava') {
            key.setPosition((this.row2[i - 1].x - 4) + (this.row2[i - 1].width / 2 + key.width / 2) - 1.4, this.row2[0].y);
          }
          else if (gameData.gameStyle === 'Rnbow') {
            key.setPosition(this.row2[i - 1].x + (this.row2[i - 1].width / 2 + key.width / 2) - 5.5, this.row2[0].y);
          }
          else if (gameData.gameStyle === 'SciFi') {
            key.setPosition(this.row2[i - 1].x + (this.row2[i - 1].width / 2 + key.width / 2) + 5.4, this.row2[0].y);
          }
          else if (gameData.gameStyle === 'Slime') {
            key.setPosition(this.row2[i - 1].x + (this.row2[i - 1].width / 2 + key.width / 2) + 4, this.row2[0].y);
          }
          else {
            key.setPosition(this.row2[i - 1].x + (this.row2[i - 1].width / 2 + key.width / 2) + 2.5, this.row2[0].y);
          }
        }
      }

      key.setStartPos(key.x, key.y);

      this.row2.push(key);
      this.allKeys.push(key);
    }
  }

  createRow3() {
    // console.log(gameData.layout[2]);
    this.row3 = [];
    this.shuffledRow3 = [];

    for (let i = 0; i < gameData.layout[2].length; i++) {
      const key = new KeyboardKey(this.scene, `${gameData.gameStyle}_${gameData.layout[2][i]}`);
      this.add(key);
      key.name = gameData.layout[2][i];

      if (i === 0) {
        if (gameData.gameStyle === 'Lava') {
          key.setPosition(-381, 0);
        }
        else if (gameData.gameStyle === 'Rnbow') {
          key.setPosition(-385, -5);
        }
        else if (gameData.gameStyle === 'Slime') {
          key.setPosition(-378, 0);
        }
        else {
          key.setPosition(-381, 0);
        }
      }
      else {
        if (i === 1) {
          if (gameData.gameStyle === 'Lava') {
            key.setPosition(-301, this.row3[0].y);
          }
          else if (gameData.gameStyle === 'Rnbow') {
            key.setPosition(-305, this.row3[0].y);
          }
          else if (gameData.gameStyle === 'Slime') {
            key.setPosition(-299, this.row3[0].y);
          }
          else {
            key.setPosition(-301, this.row3[0].y);
          }
        }
        else {
          if (gameData.gameStyle === 'Lava') {
            key.setPosition((this.row3[i - 1].x - 4) + (this.row3[i - 1].width / 2 + key.width / 2) - 1.4, this.row3[0].y);
          }
          else if (gameData.gameStyle === 'Rnbow') {
            key.setPosition(this.row3[i - 1].x + (this.row3[i - 1].width / 2 + key.width / 2) - 5.5, this.row3[0].y);
          }
          else if (gameData.gameStyle === 'SciFi') {
            key.setPosition(this.row3[i - 1].x + (this.row3[i - 1].width / 2 + key.width / 2) + 5.4, this.row3[0].y);
          }
          else if (gameData.gameStyle === 'Slime') {
            key.setPosition(this.row3[i - 1].x + (this.row3[i - 1].width / 2 + key.width / 2) + 4, this.row3[0].y);
          }
          else {
            key.setPosition(this.row3[i - 1].x + (this.row3[i - 1].width / 2 + key.width / 2) + 2.5, this.row3[0].y);
          }
        }
      }

      key.setStartPos(key.x, key.y);

      this.row3.push(key);
      this.allKeys.push(key);
    }
  }

  createRow4() {
    // console.log(gameData.layout[3]);
    this.row4 = [];
    this.shuffledRow4 = [];

    for (let i = 0; i < gameData.layout[3].length; i++) {
      const key = new KeyboardKey(this.scene, `${gameData.gameStyle}_${gameData.layout[3][i]}`);
      this.add(key);
      key.name = gameData.layout[3][i];

      if (i === 0) {
        if (gameData.gameStyle === 'Lava') {
          key.setPosition(-364, 58);
        }
        else if (gameData.gameStyle === 'Rnbow') {
          key.setPosition(-367, 54);
        }
        else if (gameData.gameStyle === 'Slime') {
          key.setPosition(-362, 58);
        }
        else if (gameData.gameStyle === 'SciFi') {
          key.setPosition(-364, 59);
        }
        else {
          key.setPosition(-364, 58);
        }
      }
      else {
        if (i === 1) {
          if (gameData.gameStyle === 'Lava') {
            key.setPosition(-267, this.row4[0].y);
          }
          else if (gameData.gameStyle === 'Rnbow') {
            key.setPosition(-271, this.row4[0].y);
          }
          else if (gameData.gameStyle === 'Slime') {
            key.setPosition(-264, this.row4[0].y);
          }
          else {
            key.setPosition(-267, this.row4[0].y);
          }
        }
        else if (i === gameData.layout[3].length - 1) {
          if (gameData.gameStyle === 'Lava') {
            key.setPosition((this.row4[i - 1].x - 8) + (this.row4[i - 1].width / 2 + key.width / 2) + 2, this.row4[0].y);
          }
          else if (gameData.gameStyle === 'Rnbow') {
            key.setPosition(this.row4[i - 1].x + (this.row4[i - 1].width / 2 + key.width / 2) - 6, this.row4[0].y);
          }
          else if (gameData.gameStyle === 'Classic') {
            key.setPosition(this.row4[i - 1].x + (this.row4[i - 1].width / 2 + key.width / 2) + 3, this.row4[0].y);
          }
          else {
            key.setPosition(this.row4[i - 1].x + (this.row4[i - 1].width / 2 + key.width / 2) + 5, this.row4[0].y);
          }
        }
        else {
          if (gameData.gameStyle === 'Lava') {
            key.setPosition((this.row4[i - 1].x - 4) + (this.row4[i - 1].width / 2 + key.width / 2) - 1.6, this.row4[0].y);
          }
          else if (gameData.gameStyle === 'Rnbow') {
            key.setPosition(this.row4[i - 1].x + (this.row4[i - 1].width / 2 + key.width / 2) - 5.6, this.row4[0].y);
          }
          else if (gameData.gameStyle === 'SciFi') {
            key.setPosition(this.row4[i - 1].x + (this.row4[i - 1].width / 2 + key.width / 2) + 5.4, this.row4[0].y);
          }
          else if (gameData.gameStyle === 'Slime') {
            key.setPosition(this.row4[i - 1].x + (this.row4[i - 1].width / 2 + key.width / 2) + 4.2, this.row4[0].y);
          }
          else {
            key.setPosition(this.row4[i - 1].x + (this.row4[i - 1].width / 2 + key.width / 2) + 2.4, this.row4[0].y);
          }
        }
      }

      key.setStartPos(key.x, key.y);

      // this.add(key);
      this.row4.push(key);
      this.allKeys.push(key);
    }
  }

  createRow5() {
    // console.log(gameData.layout[4]);
    this.row5 = [];
    this.shuffledRow5 = [];

    for (let i = 0; i < gameData.layout[4].length; i++) {
      const key = new KeyboardKey(this.scene, `${gameData.gameStyle}_${gameData.layout[4][i]}`);
      this.add(key);
      key.name = gameData.layout[4][i];

      if (i === 0) {
        if (gameData.gameStyle === 'Lava') {
          key.setPosition(-386, 116);
        }
        else if (gameData.gameStyle === 'Rnbow') {
          key.setPosition(-390, 113);
        }
        else if (gameData.gameStyle === 'Slime') {
          key.setPosition(-384, 118);
        }
        else {
          key.setPosition(-386, 117);
        }
      }
      else if (i === 3) {
        if (gameData.gameStyle === 'Lava') {
          key.setPosition(0, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'Slime') {
          key.setPosition(2, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'Rnbow') {
          key.setPosition(-4, this.row5[0].y);
        }
        else {
          key.setPosition(0, this.row5[0].y);
        }
      }
      else if (i === 4) {
        if (gameData.gameStyle === 'Lava') {
          key.setPosition(219, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'Rnbow') {
          key.setPosition(217, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'Slime') {
          key.setPosition(223, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'SciFi') {
          key.setPosition(219, this.row5[0].y);
        }
        else {
          key.setPosition(222, this.row5[0].y);
        }
      }
      else if (i > 4) {
        if (gameData.gameStyle === 'Lava') {
          key.setPosition(this.row5[i - 1].x + (this.row5[i - 1].width / 2 + key.width / 2) - 5, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'Rnbow') {
          key.setPosition(this.row5[i - 1].x + (this.row5[i - 1].width / 2 + key.width / 2) - 6, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'SciFi') {
          key.setPosition(this.row5[i - 1].x + (this.row5[i - 1].width / 2 + key.width / 2) + 5.2, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'Slime') {
          key.setPosition(this.row5[i - 1].x + (this.row5[i - 1].width / 2 + key.width / 2) + 5, this.row5[0].y);
        }
        else {
          key.setPosition(this.row5[i - 1].x + (this.row5[i - 1].width / 2 + key.width / 2) + 2, this.row5[0].y);
        }
      }
      else {
        if (gameData.gameStyle === 'Lava') {
          key.setPosition(this.row5[i - 1].x + (this.row5[i - 1].width / 2 + key.width / 2) - 6, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'Rnbow') {
          key.setPosition(this.row5[i - 1].x + (this.row5[i - 1].width / 2 + key.width / 2) - 5, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'SciFi') {
          key.setPosition(this.row5[i - 1].x + (this.row5[i - 1].width / 2 + key.width / 2) + 5.3, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'Slime') {
          key.setPosition(this.row5[i - 1].x + (this.row5[i - 1].width / 2 + key.width / 2) + 4, this.row5[0].y);
        }
        else if (gameData.gameStyle === 'Wood') {
          key.setPosition(this.row5[i - 1].x + (this.row5[i - 1].width / 2 + key.width / 2) + 3, this.row5[0].y);
        }
        else {
          key.setPosition(this.row5[i - 1].x + (this.row5[i - 1].width / 2 + key.width / 2) + 3, this.row5[0].y);
        }
      }

      key.setStartPos(key.x, key.y);

      this.row5.push(key);
      this.allKeys.push(key);
    }
  }

  enableKeys() {
    for (let i = 0; i < this.allKeys.length; i++) {
      this.allKeys[i].enableKey();
    }
  }

  disableKeys() {
    for (let i = 0; i < this.allKeys.length; i++) {
      this.allKeys[i].disableKey();
    }
  }

  hideAllKeys(tween) {
    for (let i = 0; i < this.allKeys.length; i++) {
      if (tween) {
        ABCyaPhaser.Tweens.addTween(this.allKeys[i], 500, { scaleX: 1.25, scaleY: 1.25, alpha: 0 }, Phaser.Math.Easing.Linear);
      }
      else {
        this.allKeys[i].setAlpha(0);
        this.allKeys[i].setScale(1.25, 1.25);
      }
    }
  }

  hideSymbols(tween) {
    // console.log("hiding symbols");
    for (let i = 0; i < this.allKeys.length; i++) {
      for (let l = 0; l < gameData.symbols.length; l++) {
        if (gameData.symbols.indexOf(this.allKeys[i].name) !== -1) {
          if (tween) {
            ABCyaPhaser.Tweens.addTween(this.allKeys[i], 500, { scaleX: 1, scaleY: 1, alpha: .25 }, Phaser.Math.Easing.Linear);
          }
          else {
            this.allKeys[i].setAlpha(.25);
          }
        }
      }
    }
  }

  unhideAllKeys(tween) {
    // console.log("unhiding all", tween);
    for (let i = 0; i < this.allKeys.length; i++) {
      if (tween) {
        ABCyaPhaser.Tweens.addTween(this.allKeys[i], 500, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Bounce.Out);
      }
      else {
        this.allKeys[i].setAlpha(1);
        this.allKeys[i].setScale(1, 1);
      }
    }
  }

  unhideSymbols(tween) {
    // console.log("unhiding symbols", this.allKeys[0].name);
    for (let i = 0; i < this.allKeys.length; i++) {
      for (let l = 0; l < gameData.symbols.length; l++) {
        if (gameData.symbols.indexOf(this.allKeys[i].name) !== -1) {
          if (tween) {
            ABCyaPhaser.Tweens.addTween(this.allKeys[i], 1500, { alpha: 1 }, Phaser.Math.Easing.Linear);
          }
          else {
            this.allKeys[i].setAlpha(1);
            this.allKeys[i].setScale(1, 1);
          }
        }
      }
    }
  }

  unhideLetters(tween) {
    // console.log("unhiding letters", this.allKeys[0].name);
    for (let i = 0; i < this.allKeys.length; i++) {
      for (let l = 0; l < gameData.letterNumbers.length; l++) {
        if (gameData.letterNumbers.indexOf(this.allKeys[i].name) !== -1) {
          if (this.allKeys[i].alpha === 0) {
            if (tween) {
              ABCyaPhaser.Tweens.addTween(this.allKeys[i], 500, { scaleX: 1, scaleY: 1, alpha: 1 }, Phaser.Math.Easing.Bounce.Out);
            }
            else {
              this.allKeys[i].setAlpha(1);
              this.allKeys[i].setScale(1, 1);
            }
          }
        }
      }
    }
  }

  lockSymbols() {
    // console.log("unhiding symbols", this.allKeys[0].name);
    for (let i = 0; i < this.allKeys.length; i++) {
      for (let l = 0; l < gameData.symbols.length; l++) {
        if (gameData.symbols.indexOf(this.allKeys[i].name) !== -1) {
          this.allKeys[i].isPlaced = true;
        }
      }
    }
  }

  shuffleKeys() {
    this.rowWidths = [0, 0, 0, 0, 0];

    if (gameData.gameMode === 'all') {
      this.rowYs = [-470, -405, -340, -275, -210];
    }
    else {
      this.rowYs = [-440, -375, -310, -245, -180];
    }

    let spacing;
    if (gameData.gameStyle === 'Lava' || gameData.gameStyle === 'Rnbow') spacing = 0;
    else if (gameData.gameStyle === 'Slime' || gameData.gameStyle === 'SciFi') spacing = 8;
    else if (gameData.gameStyle === 'Classic' || gameData.gameStyle === 'Wood') spacing = 7;

    for (let l = 0; l < this.allKeys.length; l++) {
      if (gameData.gameMode === 'all') {
        if (gameData.shuffledKeys[0].indexOf(this.allKeys[l].name) !== -1) {
          this.rowWidths[0] += this.allKeys[l].width + spacing;
          this.shuffledRow1.push({ key: this.allKeys[l], name: this.allKeys[l].name, startX: this.allKeys[l].startX, startY: this.allKeys[l].startY, shuffledX: 0, shuffledY: 0, space: spacing });
        }
        else if (gameData.shuffledKeys[1].indexOf(this.allKeys[l].name) !== -1) {
          this.rowWidths[1] += this.allKeys[l].width + spacing;
          this.shuffledRow2.push({ key: this.allKeys[l], name: this.allKeys[l].name, startX: this.allKeys[l].startX, startY: this.allKeys[l].startY, shuffledX: 0, shuffledY: 0, space: spacing });
        }
        else if (gameData.shuffledKeys[2].indexOf(this.allKeys[l].name) !== -1) {
          this.rowWidths[2] += this.allKeys[l].width + spacing;
          this.shuffledRow3.push({ key: this.allKeys[l], name: this.allKeys[l].name, startX: this.allKeys[l].startX, startY: this.allKeys[l].startY, shuffledX: 0, shuffledY: 0, space: spacing });
        }
        else if (gameData.shuffledKeys[3].indexOf(this.allKeys[l].name) !== -1) {
          this.rowWidths[3] += this.allKeys[l].width + spacing;
          this.shuffledRow4.push({ key: this.allKeys[l], name: this.allKeys[l].name, startX: this.allKeys[l].startX, startY: this.allKeys[l].startY, shuffledX: 0, shuffledY: 0, space: spacing });
        }
        else if (gameData.shuffledKeys[4].indexOf(this.allKeys[l].name) !== -1) {
          this.rowWidths[4] += this.allKeys[l].width + spacing;
          this.shuffledRow5.push({ key: this.allKeys[l], name: this.allKeys[l].name, startX: this.allKeys[l].startX, startY: this.allKeys[l].startY, shuffledX: 0, shuffledY: 0, space: spacing });
        }
      }
      else {
        if (gameData.shuffledLesserKeys[0].indexOf(this.allKeys[l].name) !== -1) {
          this.rowWidths[0] += this.allKeys[l].width + spacing;
          this.shuffledRow1.push({ key: this.allKeys[l], name: this.allKeys[l].name, startX: this.allKeys[l].startX, startY: this.allKeys[l].startY, shuffledX: 0, shuffledY: 0, space: spacing });
        }
        else if (gameData.shuffledLesserKeys[1].indexOf(this.allKeys[l].name) !== -1) {
          this.rowWidths[1] += this.allKeys[l].width + spacing;
          this.shuffledRow2.push({ key: this.allKeys[l], name: this.allKeys[l].name, startX: this.allKeys[l].startX, startY: this.allKeys[l].startY, shuffledX: 0, shuffledY: 0, space: spacing });
        }
        else if (gameData.shuffledLesserKeys[2].indexOf(this.allKeys[l].name) !== -1) {
          this.rowWidths[2] += this.allKeys[l].width + spacing;
          this.shuffledRow3.push({ key: this.allKeys[l], name: this.allKeys[l].name, startX: this.allKeys[l].startX, startY: this.allKeys[l].startY, shuffledX: 0, shuffledY: 0, space: spacing });
        }
        else if (gameData.shuffledLesserKeys[3].indexOf(this.allKeys[l].name) !== -1) {
          this.rowWidths[3] += this.allKeys[l].width + spacing;
          this.shuffledRow4.push({ key: this.allKeys[l], name: this.allKeys[l].name, startX: this.allKeys[l].startX, startY: this.allKeys[l].startY, shuffledX: 0, shuffledY: 0, space: spacing });
        }
      }
    }

    this.sortKeys();
  }

  setAltPos() {
    this.row4[0].setAltPos(this.row4[this.row4.length - 1].x, this.row4[this.row4.length - 1].y, this.row4[this.row4.length - 1]);
    this.row4[this.row4.length - 1].setAltPos(this.row4[0].x, this.row4[0].y, this.row4[0]);

    this.row5[0].setAltPos(this.row5[this.row5.length - 1].x, this.row5[this.row5.length - 1].y, this.row5[this.row5.length - 1]);
    this.row5[this.row5.length - 1].setAltPos(this.row5[0].x, this.row5[0].y, this.row5[0]);

    this.row5[1].setAltPos(this.row5[this.row5.length - 2].x, this.row5[this.row5.length - 2].y, this.row5[this.row5.length - 2]);
    this.row5[this.row5.length - 2].setAltPos(this.row5[1].x, this.row5[1].y, this.row5[1]);

    this.row5[2].setAltPos(this.row5[this.row5.length - 3].x, this.row5[this.row5.length - 3].y, this.row5[this.row5.length - 3]);
    this.row5[this.row5.length - 3].setAltPos(this.row5[2].x, this.row5[2].y, this.row5[2]);
  }

  sortKeys() {
    if (gameData.gameMode === 'all') {
      ABCyaPhaser.Audio.playOneShot('keyboard_swirl_long', this.scene);

      this.setAltPos();

      this.shuffledArrays = [{ array: this.shuffledRow1, width: this.rowWidths[0] }, { array: this.shuffledRow2, width: this.rowWidths[1] }, { array: this.shuffledRow3, width: this.rowWidths[2] }, { array: this.shuffledRow4, width: this.rowWidths[3] }, { array: this.shuffledRow5, width: this.rowWidths[4] }];
      this.shuffledArrays = ABCyaPhaser.Arrays.shuffle(this.shuffledArrays);

      this.shuffledRow1 = ABCyaPhaser.Arrays.shuffle(this.shuffledRow1);
      this.shuffledRow2 = ABCyaPhaser.Arrays.shuffle(this.shuffledRow2);
      this.shuffledRow3 = ABCyaPhaser.Arrays.shuffle(this.shuffledRow3);
      this.shuffledRow4 = ABCyaPhaser.Arrays.shuffle(this.shuffledRow4);
      this.shuffledRow5 = ABCyaPhaser.Arrays.shuffle(this.shuffledRow5);

      this.sortedKeys = [...this.allKeys];
    }
    else {
      ABCyaPhaser.Audio.playOneShot('keyboard_swirl_short', this.scene);

      this.shuffledArrays = [{ array: this.shuffledRow1, width: this.rowWidths[0] }, { array: this.shuffledRow2, width: this.rowWidths[1] }, { array: this.shuffledRow3, width: this.rowWidths[2] }, { array: this.shuffledRow4, width: this.rowWidths[3] }];
      this.shuffledArrays = ABCyaPhaser.Arrays.shuffle(this.shuffledArrays);

      this.shuffledRow1 = ABCyaPhaser.Arrays.shuffle(this.shuffledRow1);
      this.shuffledRow2 = ABCyaPhaser.Arrays.shuffle(this.shuffledRow2);
      this.shuffledRow3 = ABCyaPhaser.Arrays.shuffle(this.shuffledRow3);
      this.shuffledRow4 = ABCyaPhaser.Arrays.shuffle(this.shuffledRow4);
    }

    this.scene.time.delayedCall(2500, () => {this.scene.showNav();});

    let shuffledX;
    let shuffledY;
    for (let s = 0; s < this.shuffledArrays.length; s++) {
      for (let l = 0; l < this.shuffledArrays[s].array.length; l++) {
        const adjX = (1024 - this.shuffledArrays[s].width) / 2;

        if (l === 0) {
          shuffledX = adjX - this.x + this.shuffledArrays[s].array[l].key.width / 2;
        }
        else {
          shuffledX = this.shuffledArrays[s].array[l - 1].key.shuffledX +
                                this.shuffledArrays[s].array[l - 1].key.width / 2 +
                                this.shuffledArrays[s].array[l].key.width / 2 +
                                this.shuffledArrays[s].array[l].space;
        }
        shuffledY = this.rowYs[s];

        this.shuffledArrays[s].array[l].key.shuffledX = shuffledX;
        this.shuffledArrays[s].array[l].key.shuffledY = shuffledY;

        this.shuffledArrays[s].array[l].key.createKeyboardBezier(l);

        this.sortedKeys.push(this.shuffledArrays[s].array[l].key);
      }
    }
  }

  startOver() {
    for (let i = 0; i < this.sortedKeys.length; i++) {
      this.sortedKeys[i].disableKey();
      this.sortedKeys[i].isPlaced = false;
      ABCyaPhaser.Tweens.addTween(this.sortedKeys[i], 500, { x: this.sortedKeys[i].startX, y: this.sortedKeys[i].startY }, Phaser.Math.Easing.Quadratic.Out);
    }
    this.sortedKeys = [];

    this.scene.time.delayedCall(1000, () => {this.sortKeys();});
  }

  cleanUp() {
    this.allKeys = [];
    this.shuffledArrays = null;

    for (let i = 0; i < this.allKeys.length; i++) {
      this.allKeys[i].disableKey();
      this.allKeys[i].destroy();
    }
  }
}